module.exports = __webpack_public_path__ + "img/title.c23e6591.svg";